/* Stack Builder tweaks - moved to a theme asset (Claude, 26 Aug 2026).
   The inline <script> copy in the section is being neutralised for some
   visitors (guest sessions rendered dead grids on all three stores), while
   same-origin asset scripts run fine site-wide. This file restores the
   builder; it is GUARDED to no-op when the inline copy already executed,
   so nothing runs twice. Loaded with defer from sections/stack-builder-overrides.liquid. */
if (document.getElementById('csb-presets')) {
/* corrects a mistyped filename in the asset copy of STACK_IMG (no-op when the inline copy ran) */
STACK_IMG.s['cuban12|figaro5'] = '12mm-cuban-chain-50-5mm-figaro-chain-55-set-silver-ecom.jpg?v=1755080277';
(function(){
  /* real variant ids per chain/metal/length (UK store, fetched 26 Aug 2026).
     A missing length key means the variant does not exist on that product. */
  var CSB_VAR = {
    s: {
      cuban4:{45:58183369326973,50:44149117485205,55:44149117517973,60:44149117550741},
      cuban6:{45:58183505379709,50:45394117656725,55:45394117689493,60:45394117722261},
      cuban8:{45:58183510458749,50:44149116010645,55:44149116043413,60:45337093111957},
      cuban12:{50:44149112242325,55:44149112275093,60:45337094815893},
      rope3:{45:58183514587517,50:44149114896533,55:44149114929301,60:44149114962069},
      rope5:{50:44149116108949,55:44149116141717,60:44149116174485},
      wheat3:{45:58183572029821,50:44149124071573,55:44149124104341,60:44149124137109},
      wheat5:{50:44149115224213,55:44149115256981,60:44149115289749},
      figaro3:{50:44149118206101,55:44149118238869,60:44149118271637},
      figaro5:{50:44149114634389,55:44149114667157,60:44149114699925},
      connell2:{45:58183461241213,50:44149114011797,55:44149114044565,60:44149114077333}
    },
    g: {
      cuban4:{45:58183351435645,50:44149116338325,55:44149116371093,60:44149116403861},
      cuban6:{45:58183505281405,50:45394116935829,55:45394116968597,60:45394117001365},
      cuban8:{45:58183507640701,50:44149124006037,55:44149124038805,60:45337090982037},
      cuban12:{50:44149112766613,55:44149112799381,60:45337094619285},
      rope3:{45:58183514095997,50:44149114765461,55:44149114798229,60:44149114830997},
      rope5:{50:44149115060373,55:44149115093141,60:44149115125909},
      wheat3:{45:58183559184765,50:44149124202645,55:44149124235413,60:44149124268181},
      wheat5:{50:44149115715733,55:44149115748501,60:44149115781269},
      figaro3:{50:44149117747349,55:44149117780117,60:44149117812885},
      figaro5:{50:44149117190293,55:44149117223061,60:44149117255829},
      connell2:{45:58183425393021,50:44149113847957,55:44149113880725,60:44149113913493}
    }
  };

  /* live availability map rendered by Liquid into #csb-stock. Fails OPEN:
     a variant missing from the map is treated as in stock, so a collection
     hiccup can never block purchases. */
  var CSB_STOCK = {};
  try { CSB_STOCK = JSON.parse(document.getElementById('csb-stock').getAttribute('data-stock')) || {}; } catch(e){}
  /* 1 = available, 2 = out of stock, 0 = not made in this length */
  function csbOk(metal, id, len){
    var e = (CSB_VAR[metal][id]||{})[len];
    if (!e) return 0;
    var vid = (typeof e === 'object') ? e.i : e;
    return CSB_STOCK[vid] === 0 ? 2 : 1;
  }

  /* set-level discount rate baked into displayed prices. 0 = none (chain
     Stack & Save deactivated 26 Aug 2026). */
  var CSB_STACK_RATE = 0;
  function csbNet(p){ return Math.round(p * (1 - CSB_STACK_RATE) * 100) / 100; }
  CSB_MAXSAVE = (function(){
    var m = 0;
    CSB_CHAINS.forEach(function(x){ CSB_CHAINS.forEach(function(y){
      var s = (x.rrp - csbNet(x.price)) + (y.rrp - csbNet(y.price));
      if (s > m) m = s;
    });});
    return Math.floor(m);
  })();

  /* cheapest-first picker order; Connell leads */
  var CSB_ORDER = ['connell2','rope3','wheat3','figaro3','rope5','wheat5','figaro5','cuban4','cuban6','cuban8','cuban12'];
  CSB_CHAINS.sort(function(a,b){ return CSB_ORDER.indexOf(a.id) - CSB_ORDER.indexOf(b.id); });

  /* default stack = cheapest (Connell + Connell); deep links override */
  csbState.c1 = 'connell2';
  csbState.c2 = 'connell2';
  try {
    var q = new URLSearchParams(location.search);
    if (q.get('metal')==='g' || q.get('metal')==='gold') csbState.metal='g';
    if (q.get('c1') && csbById(q.get('c1'))) csbState.c1 = q.get('c1');
    if (q.get('c2') && csbById(q.get('c2'))) csbState.c2 = q.get('c2');
    if (q.get('len') && CSB_LENGTHS.some(function(l){return l.id===q.get('len')})) csbState.length = q.get('len');
  } catch(e){}

  /* if the opening pick is unavailable at the current length, open on the
     first available (cheapest) chain instead; deep-linked picks are left
     alone so shared links show their true state */
  (function(){
    var q2 = null;
    try { q2 = new URLSearchParams(location.search); } catch(e){}
    var L0 = csbLens();
    [['c1', L0[0]], ['c2', L0[1]]].forEach(function(sl){
      if (q2 && q2.get(sl[0])) return;
      if (csbOk(csbState.metal, csbState[sl[0]], sl[1]) === 1) return;
      var alt = CSB_CHAINS.filter(function(c){ return csbOk(csbState.metal, c.id, sl[1]) === 1; })[0];
      if (alt) csbState[sl[0]] = alt.id;
    });
  })();

  function csbLens(){ return [csbState.length.slice(0,2), csbState.length.slice(2)]; }
  function csbVars(){
    var L = csbLens();
    return [ (CSB_VAR[csbState.metal][csbState.c1]||{})[L[0]], (CSB_VAR[csbState.metal][csbState.c2]||{})[L[1]] ];
  }
  function csbAtcButtons(){ return document.querySelectorAll('#csb-root .csb-cta, #csb-root .csb-mobilebar button'); }
  function csbSetAtc(text, disabled){
    csbAtcButtons().forEach(function(b){ b.textContent = text; b.disabled = !!disabled; });
  }

  window.csbATC = function(){
    var v = csbVars();
    if (!v[0] || !v[1]) return;
    var a=csbById(csbState.c1), b=csbById(csbState.c2), L=csbLens();
    var key = a.name+' + '+b.name+' ('+(csbState.metal==='s'?'Silver':'Gold')+', '+L[0]+'+'+L[1]+'cm)';
    csbSetAtc('Adding…', true);
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[
        {id:v[0], quantity:1, properties:{'Stack':key}},
        {id:v[1], quantity:1, properties:{'Stack':key}}
      ]})
    }).then(function(r){
      if (!r.ok) throw new Error('add failed');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      var d = document.getElementById('cart-drawer');
      if (d) {
        setTimeout(function(){ d.setAttribute('open',''); csbSync(); }, 700);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function(){
      csbSetAtc('Out of stock — try another combo', false);
      setTimeout(function(){ csbSync(); }, 2500);
    });
  };

  function csbSync(){
    var L = csbLens();
    var s1 = csbOk(csbState.metal, csbState.c1, L[0]);
    var s2 = csbOk(csbState.metal, csbState.c2, L[1]);
    if (!s1 || !s2) { csbSetAtc('Unavailable in this length — try 50 + 55cm', true); }
    else if (s1 === 2 || s2 === 2) { csbSetAtc('Out of stock in this length — pick another chain', true); }
    else { csbSetAtc('Add stack to bag', false); }
  }

  /* 1. remove the Proven Stack step */
  var _pr = document.getElementById('csb-presets');
  if (_pr) { var _st = _pr.closest('.csb-step'); if (_st) _st.remove(); }

  /* 2. swipe arrows on the two chain pickers (mobile) */
  ['grid1','grid2'].forEach(function(gid){
    var g = document.getElementById(gid);
    if (!g) return;
    var head = g.closest('.csb-step').querySelector('.csb-stephead');
    var nav = document.createElement('span');
    nav.className = 'csb-swipenav';
    nav.innerHTML = '<button type="button" aria-label="Scroll back" onclick="document.getElementById(\''+gid+'\').scrollBy({left:-264,behavior:\'smooth\'})">&lsaquo;</button>'+
                    '<button type="button" aria-label="Scroll forward" onclick="document.getElementById(\''+gid+'\').scrollBy({left:264,behavior:\'smooth\'})">&rsaquo;</button>';
    head.appendChild(nav);
  });

  /* 3. saving chip inside the sticky bar */
  var _mbp = document.querySelector('.csb-mobilebar .p');
  if (_mbp) {
    var row = document.createElement('div');
    while (_mbp.firstChild) row.appendChild(_mbp.firstChild);
    _mbp.appendChild(row);
    var sv = document.createElement('span');
    sv.className = 'csb-mb-save'; sv.id = 'mb-save';
    _mbp.appendChild(sv);
  }

  /* 4. stack thumbnail in the buy box - tap to jump back to the big preview */
  var _bb = document.getElementById('csb-buybox');
  if (_bb) {
    var bbTop = document.createElement('div'); bbTop.className = 'csb-bb-top';
    var th = document.createElement('div'); th.className = 'csb-bb-thumb';
    th.innerHTML = '<img id="bb-thumb" alt="Your stack"><span>See your stack</span>';
    th.onclick = function(){ document.querySelector('.csb-stage').scrollIntoView({behavior:'smooth', block:'center'}); };
    var info = document.createElement('div'); info.className = 'csb-bb-info';
    info.appendChild(_bb.querySelector('.csb-bb-head'));
    info.appendChild(_bb.querySelector('.csb-bb-title'));
    info.appendChild(_bb.querySelector('.csb-bb-price'));
    bbTop.appendChild(th); bbTop.appendChild(info);
    _bb.insertBefore(bbTop, _bb.firstChild);
  }

  /* 4b. length chip overlaid on the stack preview */
  var _shot = document.querySelector('#csb-root .csb-shot');
  if (_shot && !document.getElementById('csb-lenchip')) {
    var _lc = document.createElement('span');
    _lc.id = 'csb-lenchip';
    _shot.appendChild(_lc);
  }

  /* 5. relabel the saving row + What's included under both ATCs */
  var _ssRow = document.getElementById('stackSave');
  if (_ssRow) {
    var lbl = _ssRow.parentElement.querySelector('.n');
    if (lbl) lbl.textContent = 'Total saving vs RRP';
  }
  document.querySelectorAll('#csb-root .csb-sbody .csb-cta, #csb-root .csb-buybox .csb-cta').forEach(function(btn){
    var inc = document.createElement('div');
    inc.className = 'csb-inc';
    inc.innerHTML = '<b>What’s included</b><ul class="csb-inc-list"></ul>';
    btn.insertAdjacentElement('afterend', inc);
  });

  /* 6. wire every ATC button to the real cart */
  csbAtcButtons().forEach(function(b){ b.onclick = window.csbATC; });

  /* 6c. re-dispatch pickers through the overridable global render (the asset
     copy of the main script is block-scoped, so its internal csbRender
     reference would otherwise bypass the override below) */
  window.csbSetMetal = function(m){ csbState.metal=m; window.csbRender(); };
  window.csbSetLength = function(id){ csbState.length=id; window.csbRender(); };
  window.csbPick = function(slot,id){ if(slot===1){ csbState.c1=id; } else { csbState.c2=id; } window.csbRender(); };
  window.csbPreset = function(a,b){ csbState.c1=a; csbState.c2=b; window.csbRender(); window.scrollTo({top:0,behavior:'smooth'}); };

  /* 6b. availability-aware chain cards (replaces main csbChainCard) */
  csbChainCard = function(c,slot,selected){
    var L = csbLens();
    var st = csbOk(csbState.metal, c.id, slot===1 ? L[0] : L[1]);
    var csbBadge = st===1 ? (c.top ? '<span class="csb-badge">Best seller</span>' : (c.top2 && slot===2 ? '<span class="csb-badge csb-red">Top pick</span>' : ''))
      : '<span class="csb-badge csb-oosbadge">'+(st===0?'Not in this length':'Out of stock')+'</span>';
    return '<div class="csb-card'+(selected?' on':'')+(st===1?'':(st===2?' csb-oos':' csb-oos csb-na'))+'"'+(st===1?' onclick="csbPick('+slot+',\''+c.id+'\')"':'')+'>'+csbBadge+
      '<span class="csb-tick">&#10003;</span><img loading="lazy" src="'+CSB_CDN+c.img[csbState.metal]+'" alt="'+c.name+'">'+
      '<div class="csb-cbody"><div class="csb-cname">'+c.name+'</div>'+
      '<div class="csb-cprice">'+csbGbp(csbNet(c.price))+'<s>'+csbGbp(c.rrp)+'</s>'+'</div></div></div>';
  };

  /* 7. charged-price framing + rerender covering the new elements (replaces main csbRender) */
  window.csbRender = function(){
    document.getElementById('mSilver').className = csbState.metal==='s'?'on':'';
    document.getElementById('mGold').className = csbState.metal==='g'?'on':'';
    document.getElementById('csb-lengths').innerHTML = CSB_LENGTHS.map(function(l){
      return '<div class="csb-lencard'+(csbState.length===l.id?' on':'')+'" onclick="csbSetLength(\''+l.id+'\')">'+
        (l.popular?'<span class="csb-badge">Most popular</span>':'')+'<b>'+l.label+'</b><span>'+l.note+'</span></div>';
    }).join('');
    document.getElementById('grid1').innerHTML = CSB_CHAINS.map(function(c){return csbChainCard(c,1,csbState.c1===c.id)}).join('');
    document.getElementById('grid2').innerHTML = CSB_CHAINS.map(function(c){return csbChainCard(c,2,csbState.c2===c.id)}).join('');

    var a=csbById(csbState.c1), b=csbById(csbState.c2);
    var len=CSB_LENGTHS.find(function(l){return l.id===csbState.length});
    var lens=len.label.replace('cm','').split(' + ');
    var n1=csbNet(a.price), n2=csbNet(b.price);
    var total=n1+n2, rrpTot=a.rrp+b.rrp, save=rrpTot-total;
    var metal = csbState.metal==='s'?'Silver':'Gold';
    var saveTxt = 'Save '+csbGbp(save);

    document.querySelector('.csb-savebar').innerHTML = 'Save up to <b>£'+CSB_MAXSAVE+'</b> off RRP on your stack';
    document.getElementById('stackimg').src = CSB_CDN + csbStackImg(csbState.c1, csbState.c2);
    var th2 = document.getElementById('bb-thumb');
    if (th2) th2.src = CSB_CDN + csbStackImg(csbState.c1, csbState.c2);
    document.getElementById('stackcap').textContent = a.name+' + '+b.name;
    var _lc2 = document.getElementById('csb-lenchip');
    if (_lc2) _lc2.textContent = lens[0]+' + '+lens[1]+'cm';
    document.getElementById('n1l').textContent = a.name+' ('+metal+') · '+lens[0]+'cm';
    document.getElementById('n2l').textContent = b.name+' ('+metal+') · '+lens[1]+'cm';
    document.getElementById('p1').innerHTML = csbGbp(n1)+' <s style="color:var(--mid)">'+csbGbp(a.rrp)+'</s>';
    document.getElementById('p2').innerHTML = csbGbp(n2)+' <s style="color:var(--mid)">'+csbGbp(b.rrp)+'</s>';
    document.getElementById('stackSave').textContent = '−'+csbGbp(save);
    document.getElementById('csb-rrp').textContent = csbGbp(rrpTot);
    document.getElementById('total').textContent = csbGbp(total);
    document.getElementById('chip').textContent = saveTxt;
    document.getElementById('mrrp').textContent = csbGbp(rrpTot);
    document.getElementById('mtotal').textContent = ' '+csbGbp(total);
    var mbs = document.getElementById('mb-save');
    if (mbs) mbs.textContent = saveTxt;
    document.getElementById('bb-title').textContent = a.name+' + '+b.name+' ('+metal+') · '+lens[0]+' + '+lens[1]+'cm';
    document.getElementById('bb-rrp').textContent = csbGbp(rrpTot);
    document.getElementById('bb-total').textContent = csbGbp(total);
    document.getElementById('bb-chip').textContent = saveTxt;
    document.querySelectorAll('.csb-inc-list').forEach(function(ul){
      ul.innerHTML = '<li>'+a.name+' ('+metal+') chain · '+lens[0]+'cm</li>'+
        '<li>'+b.name+' ('+metal+') chain · '+lens[1]+'cm</li>'+
        '<li>CRAFTD gift packaging</li>'+
        '<li>Lifetime Guarantee on both chains</li>';
    });
    csbSync();
  };
  csbRender();
})();
}
